import {
    FETCH_FAVORITES_SUCCESS,
    FETCH_FAVORITES_ERROR,
    FAVORITE_STYLE_SUCCESS,
    UNFAVORITE_STYLE_SUCCESS
} from '../actions/favoritesActions';

export function favoritesReducer(state, action) {
    switch (action.type) {
        case FETCH_FAVORITES_SUCCESS: {
            return Object.assign({}, state, {
                favoritedStyles: action.payload.styles
            });
        }

        case FETCH_FAVORITES_ERROR: {
            return state;
        }

        case FAVORITE_STYLE_SUCCESS: {
            return Object.assign({}, state, {
                favoritedStyles: Object.assign({}, state.favoritedStyles, {
                    [action.payload.styleNumber]: action.payload.styleNumber
                })
            });
        }

        case UNFAVORITE_STYLE_SUCCESS: {
            const currentCore = Object.assign({}, state);
            delete currentCore.favoritedStyles[action.payload.styleNumber];
            return currentCore;
        }

        default:
            return state;
    }
}
